/* eslint-disable consistent-return */
import { useRef, useEffect } from "react";
/** Hook for detection if an element is visible in viewport */
export function useInView({ rootElement, visibleOffset = 0, idleTimeout = 500, isEnabled = true, visibleThreshold, onChange, }) {
    const intersectionRef = useRef(null);
    const idleCallbackID = useRef(undefined);
    useEffect(() => {
        const intersectionElement = intersectionRef.current;
        if (isEnabled && intersectionElement) {
            const observer = new IntersectionObserver((entries) => {
                // Optimization to run during a browser's idle periods
                if (window === null || window === void 0 ? void 0 : window.requestIdleCallback) {
                    idleCallbackID.current = window.requestIdleCallback(() => onChange(entries[0].isIntersecting), {
                        timeout: idleTimeout,
                    });
                }
                else {
                    onChange(entries[0].isIntersecting);
                }
            }, {
                threshold: visibleThreshold,
                root: rootElement,
                rootMargin: `${visibleOffset}px 0px ${visibleOffset}px 0px`,
            });
            observer.observe(intersectionElement);
            return () => {
                if (!!(window === null || window === void 0 ? void 0 : window.cancelIdleCallback) && idleCallbackID.current) {
                    window.cancelIdleCallback(idleCallbackID.current);
                }
                if (intersectionElement) {
                    observer.unobserve(intersectionElement);
                }
            };
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnabled, intersectionRef, idleTimeout, visibleOffset, rootElement]);
    return { ref: intersectionRef };
}
//# sourceMappingURL=useInView.js.map